import { render, staticRenderFns } from "./CardInfoTags.vue?vue&type=template&id=76f825b2"
import script from "./CardInfoTags.vue?vue&type=script&lang=js"
export * from "./CardInfoTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonLink: require('/srv/app/components/button/Link.vue').default})
